export default "__VITE_ASSET__6E3qTPOh__"